"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoleFieldIds = void 0;
exports.displayName = displayName;
exports.PoleFieldIds = {
    POLE_NUMBER: 'poleNumber',
    POLE_ID: 'poleID',
    IMAGES: 'images',
    POLE_TYPE: 'poleType',
    POLE_OWNER: 'poleOwner',
    CIRCUMFERENCE: 'circumference',
    NOTE: 'note',
    AGL: 'agl',
    GEOGRAPHIC_COORDINATE: 'geographicCoordinate',
    IKE_PHOTO: 'trueSizeCapture',
    STATUS: 'status',
    PLA_RESULT: 'plaResult',
    SPAN: {
        FORM: 'span',
        TYPE: 'spanType',
        LENGTH: 'spanLength',
        ENVIRONMENT: 'spanEnvironment',
        MID_SPAN_PHOTO: 'spanMidSpanPhoto',
        NOTE: 'spanNote',
        // Fields added as part of Base Form
        WIRE: {
            FORM: 'spanWire',
            MID_SPAN_HEIGHT: 'spanWireMidSpanHeight',
            USAGE_GROUP: 'spanWireUsageGroup',
            OWNER: 'spanWireOwner',
            ATTACHMENT_HEIGHT: 'spanWireAttachmentHeight',
        },
    },
    CIRCUIT: {
        FORM: 'circuit',
        CONSTRUCTION: 'circuitConstruction',
        MID_SPAN_HEIGHT: 'circuitMidSpanHeight',
    },
    WIRE: {
        FORM: 'wire',
        OWNER: 'wireOwner',
        INSULATOR: 'wireInsulator',
        ATTACHMENT_HEIGHT: 'wireAttachmentHeight',
        SIZE: 'wireSize',
        QUANTITY: 'wireQuantity',
    },
    ANCHOR: {
        FORM: 'anchor',
        TYPE: 'anchorType',
        OWNER: 'anchorOwner',
        LENGTH: 'anchorLeadLength',
        NOTE: 'anchorNote',
        // Fields added as part of Base Form
        GUY: {
            FORM: 'anchorGuy',
            SIZE: 'anchorGuySize',
            OWNER: 'anchorGuyOwner',
            ATTACHMENT_HEIGHT: 'anchorGuyAttachmentHeight',
        },
    },
    GUY: {
        FORM: 'guys',
        SIZE: 'guySize',
        OWNER: 'guyOwner',
        ATTACHMENT_HEIGHT: 'guyAttachmentHeight',
    },
    EQUIPMENT: {
        FORM: 'equipment',
        TYPE: 'equipmentType',
        ATTACHMENT_HEIGHT: 'equipmentAttachmentHeight',
        ATTACHMENT_BOTTOM_HEIGHT: 'equipmentBottomHeight',
        ORIENTATION: 'equipmentOrientation',
        QUANTITY: 'equipmentQuantity',
        OWNER: 'equipmentOwner',
        NOTE: 'equipmentNote',
    },
    SPAN_GUY: {
        FORM: 'spanGuys',
        SIZE: 'spanGuySize',
        OWNER: 'spanGuyOwner',
        ATTACHMENT_HEIGHT: 'spanGuyAttachmentHeight',
        MID_SPAN_HEIGHT: 'spanGuyMidSpanHeight',
        HEIGHT_AT_WEP: 'spanGuyHeightAtWEP',
        TYPE: 'spanGuyType',
    },
    // Fields added as part of Base Form
    SEQUENCE: 'sequence',
    LOW_POWER_ATTACHMENT: 'lowPowerAttachment',
    LOW_POWER_TO_COMM: 'lowPowerToComm',
    STREET_ADDRESS: 'streetAddress',
    MAKE_READY: {
        FORM: 'makeReady',
        ATTACHMENT_SIZE: 'makeReadyAttachmentSize',
        ATTACHMENT_TYPE: 'makeReadyAttachmentType',
        ATTACHMENT_HEIGHT: 'makeReadyAttachmentHeight',
        PROPOSED_MID_SPAN: 'makeReadyProposedMidSpan',
        PROPOSED_RISER: 'makeReadyProposedRiser',
        TYPE: 'makeReadyType',
        NOTE: 'makeReadyNote',
    },
};
const PoleFieldName = {
    [exports.PoleFieldIds.POLE_NUMBER]: 'Pole Number',
    [exports.PoleFieldIds.POLE_ID]: 'Id',
    [exports.PoleFieldIds.IMAGES]: 'Tag Photos',
    [exports.PoleFieldIds.POLE_TYPE]: 'Type',
    [exports.PoleFieldIds.POLE_OWNER]: 'Owner',
    [exports.PoleFieldIds.CIRCUMFERENCE]: 'Circumference (")',
    [exports.PoleFieldIds.NOTE]: 'Note',
    [exports.PoleFieldIds.PLA_RESULT]: 'PLA Result',
    [exports.PoleFieldIds.AGL]: 'Tip',
    [exports.PoleFieldIds.GEOGRAPHIC_COORDINATE]: 'Location',
    [exports.PoleFieldIds.IKE_PHOTO]: 'IKEphoto',
    [exports.PoleFieldIds.STATUS]: 'Status',
    [exports.PoleFieldIds.SPAN.FORM]: 'Span',
    [exports.PoleFieldIds.SPAN.TYPE]: 'Type',
    [exports.PoleFieldIds.SPAN.LENGTH]: 'Span Length',
    [exports.PoleFieldIds.SPAN.ENVIRONMENT]: 'Environment',
    [exports.PoleFieldIds.SPAN.MID_SPAN_PHOTO]: 'Mid Span IKEphoto',
    [exports.PoleFieldIds.SPAN.NOTE]: 'Note',
    [exports.PoleFieldIds.CIRCUIT.FORM]: 'Circuit',
    [exports.PoleFieldIds.CIRCUIT.CONSTRUCTION]: 'Construction',
    [exports.PoleFieldIds.CIRCUIT.MID_SPAN_HEIGHT]: 'Mid Span Height',
    [exports.PoleFieldIds.WIRE.FORM]: 'Wire',
    [exports.PoleFieldIds.WIRE.OWNER]: 'Owner',
    [exports.PoleFieldIds.WIRE.INSULATOR]: 'Insulator',
    [exports.PoleFieldIds.WIRE.ATTACHMENT_HEIGHT]: 'Attachment Height',
    [exports.PoleFieldIds.WIRE.SIZE]: 'Size',
    [exports.PoleFieldIds.WIRE.QUANTITY]: 'Quantity',
    [exports.PoleFieldIds.ANCHOR.FORM]: 'Anchor',
    [exports.PoleFieldIds.ANCHOR.TYPE]: 'Type',
    [exports.PoleFieldIds.ANCHOR.OWNER]: 'Owner',
    [exports.PoleFieldIds.ANCHOR.LENGTH]: 'Lead Length',
    [exports.PoleFieldIds.ANCHOR.NOTE]: 'Note',
    [exports.PoleFieldIds.GUY.FORM]: 'Guys',
    [exports.PoleFieldIds.GUY.SIZE]: 'Size',
    [exports.PoleFieldIds.GUY.OWNER]: 'Owner',
    [exports.PoleFieldIds.GUY.ATTACHMENT_HEIGHT]: 'Attachment Height',
    [exports.PoleFieldIds.EQUIPMENT.FORM]: 'Equipment',
    [exports.PoleFieldIds.EQUIPMENT.TYPE]: 'Type',
    [exports.PoleFieldIds.EQUIPMENT.ATTACHMENT_HEIGHT]: 'Attachment Height',
    [exports.PoleFieldIds.EQUIPMENT.ATTACHMENT_BOTTOM_HEIGHT]: 'Bottom Height',
    [exports.PoleFieldIds.EQUIPMENT.ORIENTATION]: 'Orientation',
    [exports.PoleFieldIds.EQUIPMENT.QUANTITY]: 'Quantity',
    [exports.PoleFieldIds.EQUIPMENT.OWNER]: 'Owner',
    [exports.PoleFieldIds.EQUIPMENT.NOTE]: 'Note',
    [exports.PoleFieldIds.SPAN_GUY.FORM]: 'Span Guy',
    [exports.PoleFieldIds.SPAN_GUY.SIZE]: 'Size',
    [exports.PoleFieldIds.SPAN_GUY.OWNER]: 'Owner',
    [exports.PoleFieldIds.SPAN_GUY.ATTACHMENT_HEIGHT]: 'Attachment Height',
    [exports.PoleFieldIds.SPAN_GUY.MID_SPAN_HEIGHT]: 'Mid Span Height',
    [exports.PoleFieldIds.SPAN_GUY.HEIGHT_AT_WEP]: 'Height at WEP',
    [exports.PoleFieldIds.SPAN_GUY.TYPE]: 'Type',
};
function displayName(poleFieldId) {
    const display = PoleFieldName[poleFieldId];
    if (display == null) {
        throw new Error(`Display name not found for: '${poleFieldId}'`);
    }
    return display;
}
//# sourceMappingURL=FieldID.js.map